import { PlannerConfigEntity } from '@/services/configurator/PlannerConfigTypes';
import { Differ, Viewer } from 'json-diff-kit';
import 'json-diff-kit/dist/viewer.css';

type JsonDiffViewer = {
  previous: PlannerConfigEntity;
  current: PlannerConfigEntity;
};

export default function JsonDiffViewer({ previous, current }: JsonDiffViewer) {
  const differ = new Differ({
    detectCircular: true,
    showModifications: true,
    arrayDiffMethod: 'lcs',
    ignoreCase: true,
    ignoreCaseForKey: true,
    recursiveEqual: true,
  });

  return (
    <>
      <div className='flex bg-black text-white max-w-screen'>
        <div className='w-1/2 py-3 flex items-center justify-center'>
          Production data
        </div>
        <div className='w-1/2 py-3 flex items-center justify-center border-l border-black'>
          Staging data
        </div>
      </div>
      <Viewer
        diff={differ.diff(previous, current)}
        indent={2}
        lineNumbers={true}
        highlightInlineDiff={true}
        hideUnchangedLines
        inlineDiffOptions={{
          mode: 'word',
          wordSeparator: '',
        }}
      />
    </>
  );
}
